export const RESPONSIVE_BREAKPOINTS = Object.freeze({
  TABLET: 768,
  DESKTOP: 1280,
  WIDE_SCREEN: 1440,
})
